import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getFeatureLocks } from '@/actions/feature-locks/getFeatureLocks';
import { FeatureLocks } from '@/types/feature.locks.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetFeatureLocksReturn {
  result: ApiResponse<FeatureLocks> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetFeatureLocks = (): UseGetFeatureLocksReturn => {
  const query: UseQueryResult<ApiResponse<FeatureLocks>, Error> = useQuery({
    queryKey: ['feature-locks'],
    queryFn: getFeatureLocks,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
